module.exports = __webpack_public_path__ + "static/img/word.d47e67c0.png";